import React from "react";
import { Box } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { datePickerTextFieldStyles } from "./filter-styles";

dayjs.extend(utc);

interface DateRangePickerProps {
  dateFrom: string | null;
  dateTo: string | null;
  onChange: (key: string, value: unknown) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  dateFrom,
  dateTo,
  onChange,
}) => {
  const now = dayjs();

  return (
    <Box
      sx={{ display: "flex", flexDirection: "row", gap: 2 }}
      data-testid="date-filters"
    >
      <DateTimePicker
        label="From"
        value={dayjs(dateFrom)}
        maxDateTime={dayjs(dateTo) ?? now}
        onChange={(newValue) =>
          onChange("dateFrom", newValue ? newValue.utc().toISOString() : null)
        }
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            sx: datePickerTextFieldStyles,
          },
        }}
        data-testid="date-from-picker"
      />

      <DateTimePicker
        label="To"
        value={dayjs(dateTo)}
        minDateTime={dayjs(dateFrom) ?? undefined}
        maxDateTime={now}
        onChange={(newValue) =>
          onChange("dateTo", newValue ? newValue.utc().toISOString() : null)
        }
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            sx: datePickerTextFieldStyles,
          },
        }}
        data-testid="date-to-picker"
      />
    </Box>
  );
};

export default DateRangePicker;
